export default {
  inDevelopment: {
    summary: 'The Production Scheduler is in development',
    details: 'Here you will plan which jobs run on which furnace and when, based on your orders.',
  },
};
